//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconNotePencil from '@/static/img/icons/icon-note-pencil.svg?inline'
import IconStudent from '@/static/img/icons/icon-student.svg?inline'
import IconBriefcase from '@/static/img/icons/Briefcase.svg?inline'
import IconBuildings from '@/static/img/icons/icon-buildings.svg?inline'
import IconMedal from '@/static/img/icons/Medal.svg?inline'
import IconChatsTeardrop from '@/static/img/icons/ChatsTeardrop.svg?inline'
import IconHeadset from '@/static/img/icons/icon-headset.svg?inline'
import {mapGetters} from 'vuex'

export default {
  name: 'mobileMenu',
  components: {
    IconNotePencil,
    IconStudent,
    IconBriefcase,
    IconBuildings,
    IconMedal,
    IconChatsTeardrop,
    IconHeadset
  },
  created() {
    // this.$store.dispatch('tests/setDisciplines')    
  },
  data: () => ({
    link: ""
  }),
  computed: {
    ...mapGetters({
      getMobileMenuHeader: 'getMobileMenuHeader',
      getAvailableStatuses: 'competition/getAvailableStatuses',
      getStatusCode: 'competition/getStatusCode',
      getDisciplinesLength: 'tests/getDisciplinesLength'
    }),
    menuItems() {
      return this.getMobileMenuHeader
      // let menuItems = []
      // if (this.getMobileMenuHeader.length) {
      //   const applicationStatusAccepted = this.getStatusCode === this.getAvailableStatuses[['APPLICATION_STATUS_ACCEPTED']]
      //   this.getMobileMenuHeader.forEach(item => {
      //     if (item.link === '/cabinet/tests') {
      //       if (applicationStatusAccepted && !!this.getDisciplinesLength) {
      //         menuItems.push(item)
      //       }
      //     } else if (item.link === '/contracts') {
      //       if (applicationStatusAccepted) {
      //         menuItems.push(item)
      //       }
      //     } else {
      //       menuItems.push(item)
      //     }
      //   })
      // }
      // return menuItems
    },
    menu(){
      let linkList = [...this.$store.getters['getMobileMenuHeader']]
      return linkList
    },
    mobileMenuValue() {
      return this.$store.getters['mobileMenu/getMobileMenuValue']
    }
  },
  methods: {
    async logout() {
      this.$store.commit('logout/setLogout', true)
      await this.$router.push({path:  '/'})
      // let tempLink = this.link
      
      // try {
      //   const result = await this.$api('auth', {}, 'DELETE')
      //   tempLink = result.data.url
      // } catch (e) {
      //   console.error('e', e)
      // }

      // this.$store.dispatch('application/deleteDataFromLocalStorage');
      // this.$auth.$storage.setState('user', false)
      // this.$auth.strategies.local.token.reset()
      // this.$auth.strategies.local.requestHandler.reset()

      // this.$router.push({path:  '/'})
      // window.location.replace(tempLink)
    },
  }

}
